<template>
  <tr class="product-usages-details__table-row" v-if="value != undefined">
    <th class="product-usages-details__table-header">{{ title }}</th>
    <td class="product-usages-details__table-value" data-test-value>{{ value }}</td>
  </tr>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PProductUsageDetailsRow',
  props: {
    title: String,
    value: {
      type: String,
    },
  },
})
</script>

<style lang="scss">
.product-usages-details__table-row {
  display: flex;
  flex-direction: row;
  padding: 0.5rem 1.5rem;
  border-bottom: 1px solid var(--color-inactive-light);
}

.product-usages-details__table-header {
  flex: 0 0 auto;
  font-weight: normal;
}

.product-usages-details__table-value {
  width: 100%;
  text-align: right;
  font-weight: bold;
  white-space: pre-line;
}
</style>
